import React from 'react';

export default function ReturnAndRefundPolicy(props) {
    return (
        <div className="mt-4 p-4 flex flex-col text-green-500 border border-green-500">
            <div className="text-2xl mb-10">배송/교환/반품 안내</div>
        </div>
    );
}
